import { Loader2 } from 'lucide-react';

const LoadingSpinner = () => {
  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center bg-gray-100">
      <Loader2 className="h-12 w-12 text-primary animate-spin" />
    </div>
  );
};

export default LoadingSpinner;
